import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal-container w-full h-95p",
  ref: "target"
}
const _hoisted_2 = { class: "col gap-32px height-scroll" }
const _hoisted_3 = { class: "col gap-32px height-scroll" }
const _hoisted_4 = { class: "col gap-32px height-scroll w-full" }
const _hoisted_5 = { class: "col gap-32px height-scroll w-full" }
const _hoisted_6 = { class: "col gap-32px height-scroll w-full" }

import loadingSpinner from "@/views/loadingSpinner.vue";
import dashbPerson from "@/views/patientMain/dashbAdmin/person/dashbPerson.vue";
import esRelationShip from '@/views/patientMain/dashbAdmin/relationShip/esRelationship.vue';
import dashbCns from "@/views/patientMain/dashbAdmin/cns/dashbCns.vue";
import dashbStickyNotes from "./sticky/dashbStickyNotes.vue";
import dashbInvoiceHistory from "./dashbInvoiceHistory.vue";
import EsNotification from "@/views/patientMain/dashbAdmin/person/esNotification.vue";
import EsTabsModal from "@/components/tabs/esTabsModal.vue";
import EsTabModel from "@/components/tabs/esTabModel.vue";
import PersonService from "@/services/PersonService";
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { apiDateString } from "@/api/apicommon";
import { computed, useTemplateRef } from 'vue';
import EsAppointments from "@/views/patientMain/dashbAdmin/appointments/EsAppointments.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbAdmin',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();



const notificationRef = useTemplateRef('notification');
const emit = __emit;

const pwrPatientName = computed(() => {
  const person = currentEntryStore.modalPatient;
  if (!person || !person.lastName) {
    return "Patient";
  }

  return PersonService.formatName(person.lastName, person.firstName);
})

const pwrBirthDate = computed(() => {
  if (!currentEntryStore.modalPatient) return "";
  return apiDateString(currentEntryStore.modalPatient.birthDate);
})

const age = computed(() => {
  if (!currentEntryStore.modalPatient) return "";
  return currentEntryStore.modalPatient.ageTerm;
})

const hasEmails = computed(() => {
  if (!currentEntryStore.modalPatient) return false;
  const emails = currentEntryStore.modalPatient.emails;
  return emails.length > 0;
});

const closeAdminModal = (close: boolean) => {
  if(close)
    emit("modal-close");
};

const onPersonEmailsUpdated = () => {
  notificationRef.value.reloadPreferences();
}

return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "h-full w-full modal-wrapper content-transparent modal-mask",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (closeAdminModal(true)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!_unref(currentEntryStore).modalPatient)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "bg-modal es-tab-admin h-full",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(loadingSpinner, {
                  logo: false,
                  style: 'w-5',
                  class: "mtop-50"
                })
              ]))
            : (_openBlock(), _createBlock(EsTabsModal, {
                key: 1,
                onModalClose: _cache[3] || (_cache[3] = ($event: any) => (closeAdminModal(true))),
                class: "es-tab-admin",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (closeAdminModal(false)), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(EsTabModel, {
                    keyword: "patientAdmin",
                    active: true,
                    separator: false,
                    route: "patient",
                    header: pwrPatientName.value,
                    title: _unref(t)('patient.admin.title'),
                    subTitle: age.value,
                    subSubTitle: pwrBirthDate.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(dashbPerson, { onEmailUpdated: onPersonEmailsUpdated }),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full border-top" }, null, -1)),
                        _createVNode(EsNotification, {
                          ref: "notification",
                          "has-emails": hasEmails.value
                        }, null, 8, ["has-emails"]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full border-top" }, null, -1)),
                        _createVNode(dashbCns, {
                          onModalClose: _cache[1] || (_cache[1] = ($event: any) => (closeAdminModal(true)))
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["header", "title", "subTitle", "subSubTitle"]),
                  _createVNode(EsTabModel, {
                    keyword: "relationship",
                    active: false,
                    separator: false,
                    route: "patient",
                    header: pwrPatientName.value,
                    title: _unref(t)('patient.admin.relationship.title'),
                    subTitle: age.value,
                    subSubTitle: pwrBirthDate.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(esRelationShip)
                      ])
                    ]),
                    _: 1
                  }, 8, ["header", "title", "subTitle", "subSubTitle"]),
                  _createVNode(EsTabModel, {
                    keyword: "notes",
                    active: false,
                    separator: false,
                    route: "patient",
                    header: pwrPatientName.value,
                    title: _unref(t)('patient.admin.note'),
                    subTitle: age.value,
                    subSubTitle: pwrBirthDate.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(dashbStickyNotes)
                      ])
                    ]),
                    _: 1
                  }, 8, ["header", "title", "subTitle", "subSubTitle"]),
                  _createVNode(EsTabModel, {
                    keyword: "invoiceHistory",
                    active: false,
                    separator: false,
                    route: "patient",
                    header: pwrPatientName.value,
                    title: _unref(t)('patient.admin.invoiceHistory'),
                    subTitle: age.value,
                    subSubTitle: pwrBirthDate.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(dashbInvoiceHistory, {
                          onModalClose: _cache[2] || (_cache[2] = ($event: any) => (closeAdminModal(true)))
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["header", "title", "subTitle", "subSubTitle"]),
                  _createVNode(EsTabModel, {
                    keyword: "appointments",
                    active: false,
                    separator: false,
                    route: "patient",
                    header: pwrPatientName.value,
                    title: _unref(t)('patient.admin.appointments'),
                    subTitle: age.value,
                    subSubTitle: pwrBirthDate.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(EsAppointments)
                      ])
                    ]),
                    _: 1
                  }, 8, ["header", "title", "subTitle", "subSubTitle"])
                ]),
                _: 1
              }))
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})